import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './useApi.js';

interface SearchResult {
  type: 'dossier' | 'apparaat' | 'contact' | 'lead';
  id: string;
  title: string;
  subtitle: string;
  meta: string;
  linkTo: string;
}

interface SearchResponse {
  results: SearchResult[];
  totalCount: number;
}

function useDebounce(value: string, delay: number): string {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}

export function useGlobalSearch(query: string) {
  const debouncedQuery = useDebounce(query, 300);

  return useQuery({
    queryKey: ['global-search', debouncedQuery],
    queryFn: () => apiFetch<SearchResponse>(`/api/search?q=${encodeURIComponent(debouncedQuery)}`),
    enabled: debouncedQuery.length >= 2,
  });
}
